/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-2023 (original work) Open Assessment Technologies SA
 *
 */
import config from '../config.js';
import router from 'taoDeliverAppsCommon/core/router.js';

/**
 * Routing override
 * @param {String} route
 * @returns {Promise} resolves with an imported module
 */
router.importController = route => {
    const { exitPageRoutes } = config;

    switch (route) {
        case exitPageRoutes.error:
            return import('taoDeliverAppsCommon/controller/error.js');

        case exitPageRoutes.thankYou:
            return import('taoDeliverAppsCommon/controller/thankyou.js');

        default:
            return import('taoDeliverAppsCommon/controller/runner.js');
    }
};

/**
 * Routing override
 * @returns {Object} config, specific to this application, needed in common router + controllers
 */
router.getConfig = () => config;

export default router;
